import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  BasicSettings,
  Environment,
  AccessLicModel,
  IsError,
  IsErrorValues,
  ModelNum,
  ModelNumStr,
  ModelStr,
  PeriodicServices,
  AccessLicErrModel,
} from '../../models/-index';

@Injectable()
export class SystemService {
  private base: string;

  constructor(private http: HttpClient, @Inject('ENV') private env: Environment) {
    this.base = `${env.apiUrl}/api/System/`;
  }

  // super!!!
  SuperSaiyanSwitch(ss: ModelStr): Observable<IsErrorValues> {
    const u = `${this.base}SuperSaiyanSwitch`;
    return this.http.post<IsErrorValues>(u, ss);
  }
  //
  GetAccessLicMaxDevices(): Observable<IsError> {
    const u = `${this.base}GetAccessLicMaxDevices`;
    return this.http.get<IsError>(u);
  }

  //AccessLicModel versione con IsError
  GetAccessLicErrModel(): Observable<AccessLicErrModel> {
    const u = `${this.base}GetAccessLicErrModel`;
    return this.http.get<AccessLicErrModel>(u);
  }

  // gestione interna
  SetAccessLicModel(model: AccessLicModel): Observable<IsError> {
    const u = `${this.base}SetAccessLicModel`;
    return this.http.post<IsError>(u, model);
  }

  // gestione  esterna senza allow anonymous
  LicStringEncoded_ByModel(model: AccessLicModel): Observable<ModelStr> {
    const u = `${this.base}LicStringEncoded_ByModel`;
    return this.http.post<ModelStr>(u, model);
  }

  StoreLicStringEncoded(str: string): Observable<IsError> {
    const model: ModelStr = { Value: str };
    const u = `${this.base}StoreLicStringEncoded`;
    return this.http.post<IsError>(u, model);
  }
  GetAppSettings_LicenzaProvaGiorni(): Observable<ModelNum> {
    const u = `${this.base}GetAppSettings_LicenzaProvaGiorni`;
    return this.http.get<ModelNum>(u);
  }
  GetAppSettings_PeriodicServices(): Observable<PeriodicServices> {
    const u = `${this.base}GetAppSettings_PeriodicServices`;
    return this.http.get<PeriodicServices>(u);
  }
  GetAppSettings_BasicSettings(): Observable<BasicSettings> {
    const u = `${this.base}GetAppSettings_BasicSettings`;
    return this.http.get<BasicSettings>(u);
  }

  // --------------------------------------------------------------------
  // ======= zona di account controller permette [allowanonymous] =======
  // --------------------------------------------------------------------
  // [AllowAnonymous]
  ServerStoreLicEncodedInit(model: ModelNumStr): Observable<IsError> {
    const u = `${this.env.apiUrl}/api/account/ServerStoreLicEncodedInit`;
    return this.http.post<IsError>(u, model);
  }
  //  [AllowAnonymous]
  Get4SelectAzbaseInit(): Observable<ModelNumStr[]> {
    const u = `${this.env.apiUrl}/api/account/Get4SelectAzbaseInit`;
    return this.http.get<ModelNumStr[]>(u);
  }
  //  [AllowAnonymous] chiave per 1 ora usato in InitLicComponent per accedere in caso di problemi
  LicStringEncoded1Hour(): Observable<ModelStr> {
    const u = `${this.base}LicStringEncoded1Hour`;
    return this.http.get<ModelStr>(u);
  }
  // ------------------------------------------------------------------
  // ================= fine zona  account  [allowanonymous] ===========
  //-------------------------------------------------------------------
}
